import { type TranslationTree } from '@/i18n/types';

export const messages = {
  presetsTitle: 'Comece por um modelo (dá para mudar tudo depois)',
  empty: 'Nenhum botão. Sem botões, o card mostra só o cupom.',
  add: 'Adicionar botão',
  limit: {
    one: 'Até {{count}} botão',
    other: 'Até {{count}} botões',
  },
  alreadyAdded: 'Já está na oferta',
  attribution:
    'A Bodyprint identifica a origem sozinha, sem nada para configurar: o link ganha utm_source=bodyprint e o WhatsApp abre com uma mensagem que cita a oferta.',
} satisfies TranslationTree;
